import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import SwiperCore, {
	Navigation,
	Pagination,
	//Scrollbar,
	A11y,
	Lazy,
	SwiperOptions
} from 'swiper/core';


//SERVICES
import { ConfigService } from 'src/app/shared/services/config.service';
import { MockAPIProvider } from 'src/app/shared/services/mock-api.provider';
import { CompassAPIDynamicListService } from 'src/app/shared/api-compass/compass-api-dynamic-list.service';
import { MetaService } from 'src/app/shared/services/meta.service';

//MODELS
import { ImageGridItem } from 'ascedia-design-system/lib/models/image-grid-item.interface';
import { Jumbotron } from 'ascedia-design-system/lib/models/jumbotron.interface';
import { DynamicListDisplay } from 'src/app/shared/models/dynamic-list-display.interface';
import { DynamicList } from 'src/app/shared/models/dynamic-list.interface';

SwiperCore.use([
	Navigation,
	//Pagination,
	//Scrollbar,
	A11y,
	Lazy,
	// Virtual,
	// Zoom,
	// Autoplay,
	// Thumbs,
	// Controller
]);

@Component({
	selector: 'app-excursions',
	templateUrl: './excursions.component.html'
})
export class ExcursionsComponent implements OnInit {

	public breakpointsBg = {
		//lowest setting is in markup
		575: { slidesPerView: 2.25, spaceBetween: 10, slidesPerGroup: 3 },
		640: { slidesPerView: 3.25, spaceBetween: 15, slidesPerGroup: 4 },
		991: { slidesPerView: 4, spaceBetween: 20, slidesPerGroup: 4 }
	};

	public config: SwiperOptions = {
		lazy: true,
		preloadImages: false,
		slidesPerView: 1.25,
		slidesPerGroup: 1,
		spaceBetween: 10,
		breakpoints: this.breakpointsBg
	};

	public jumbotron$: Observable<Jumbotron>;
	public testImageGrid: ImageGridItem[];
	public imageGrid: ImageGridItem[];
	public jumbotronSlider$: Observable<any[]>;
	//public tabListSafety$: Observable<AccordionTab[]>;
	public sliderListBg$: Observable<any[]>;//SwiperBackgroundImage

	public sliderList$: Observable<DynamicListDisplay[]>;
	public imageGrid$: Observable<ImageGridItem[]>;

	constructor(
		private _compassAPIDynamicListService: CompassAPIDynamicListService,
		private _mockAPIProvider: MockAPIProvider,
		private _configService: ConfigService,
		private _metaService: MetaService,
		// private route: ActivatedRoute,
		// private router: Router
	) { }

	ngOnInit(): void {
		//console.log('ExcursionsComponent');
		this._metaService.updateMetaData('Excursions');
		this.getContent1();
	}

	public getContent1 () {
		//console.log('ExcursionsComponent.getContent1()');

		this.jumbotron$ = this._mockAPIProvider.load('excursion/excursions-jumbotron.json', false)
			.pipe(map((res: Jumbotron) => {
				//console.log('jumbotron$:', res);
				if(res) {
					//console.log('InfoBoxes1:', res);
					return res;
				}
				return null;
			}));

		this.sliderList$ = this.getDynamicListDisplay('bbb2eb9e-41a8-463b-8c31-a9e79e2ecf3b')
			.pipe(map((lists: DynamicListDisplay[]) => {
				if(lists && lists.length > 0) {
					return this._compassAPIDynamicListService.processDataCarousel(lists, 'bg');
				}
				return null;
			}));

		this.imageGrid$ = this.getDynamicListDisplay('5289fcfd-5ef2-481a-99eb-234fc75814e1')
			.pipe(map((lists: DynamicListDisplay[]) => {
				if(lists && lists.length > 0) {
					return this._compassAPIDynamicListService.processDataImageGrid(lists);
				}
				return null;
			}));

		this.jumbotronSlider$ = this._mockAPIProvider.load('excursion/excursions-jumbotron-slider.json', false)
			.pipe(map((res: any[]) => {
				if(res && res.length > 0) {
					//console.log('jumbotronSlider:', res);
					return res;
				}
				return null;
			}));


	}


	/**
	 * get Dynamic List By siteSectionId
	*/
	public getDynamicListDisplay(siteSectionId: string):Observable<DynamicList[]>{
		//console.log('getDynamicListDisplay', siteSectionId);
		return this._compassAPIDynamicListService.getDynamicListDisplay(siteSectionId)
			.pipe(map((data) => {
				//console.log('getDynamicListDisplay.data:', data);

                return data;
			}));

	}


}
